import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  transition: all 0.1s ease-in;
  ${(props) => props.isHidden && css`
    opacity: 0;
  `}
`;

const Figure = styled.figure`
  position: relative;
  margin: 0;
`;

const baseURL = `${process.env.REACT_APP_API_URL}/api/rest`;

function MediaImage({
  placeholderSrc, src, id, alt, width, height, className, style,
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const token = localStorage.getItem('accessToken');
  const defaultSrc = `${baseURL}/images/${id}?jwt=${token}`;
  const imgProps = {
    className,
    alt,
    width,
    height,
    style,
  };

  return (
    <Figure {...imgProps}>
      <Img
        {...imgProps}
        onLoad={() => setIsLoaded(true)}
        src={src || defaultSrc}
        isHidden={!isLoaded}
      />
      <Img
        {...imgProps}
        src={placeholderSrc}
        isHidden={isLoaded}
      />
    </Figure>
  );
}
MediaImage.propTypes = {
  placeholderSrc: PropTypes.string,
  id: PropTypes.number,
  src: PropTypes.string,
};
MediaImage.defaultProps = {
  placeholderSrc: null,
  id: null,
  src: null,
};

export default MediaImage;
